import { useLayoutEffect, useRef, useState } from "react";

// Folga mínima entre a logo e o que estiver dos lados.
const FOLGA_PX = 24;

function bordaDireitaDoConteudo(el) {
  // O menu de abas é flex-1: a caixa dele ocupa o meio todo, então o que conta
  // é onde o último botão termina, não onde a caixa termina.
  return [...el.children].reduce((max, filho) => Math.max(max, filho.getBoundingClientRect().right), el.getBoundingClientRect().left);
}

/**
 * Logo do Núcleo no centro do cabeçalho — só quando cabe. Fica escondida
 * sempre que encostaria nas abas da esquerda ou nos botões da direita, o que
 * muda com a largura da tela e com a quantidade de abas do lojista.
 */
export default function LogoCentralCabecalho({ esquerdaRef, direitaRef }) {
  const logoRef = useRef(null);
  const [cabe, setCabe] = useState(false);

  useLayoutEffect(() => {
    const medir = () => {
      const logo = logoRef.current;
      const esq = esquerdaRef.current;
      const dir = direitaRef.current;
      if (!logo || !esq || !dir) return;
      const r = logo.getBoundingClientRect();
      setCabe(r.width > 0 && r.left - FOLGA_PX >= bordaDireitaDoConteudo(esq) && r.right + FOLGA_PX <= dir.getBoundingClientRect().left);
    };
    medir();
    const tamanho = new ResizeObserver(medir);
    [esquerdaRef.current, direitaRef.current, logoRef.current].forEach((el) => el && tamanho.observe(el));
    const abas = new MutationObserver(medir);
    if (esquerdaRef.current) abas.observe(esquerdaRef.current, { childList: true });
    window.addEventListener("resize", medir);
    return () => { tamanho.disconnect(); abas.disconnect(); window.removeEventListener("resize", medir); };
  }, [esquerdaRef, direitaRef]);

  return (
    <div
      ref={logoRef}
      aria-hidden
      className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none ${cabe ? "" : "invisible"}`}
    >
      <img src="/logo-nucleo-cabecalho.png" alt="" className="h-9 w-auto dark:hidden" draggable={false} />
      <img src="/logo-nucleo-cabecalho-escuro.png" alt="" className="h-9 w-auto hidden dark:block" draggable={false} />
    </div>
  );
}
